import createStorage from './createStorage.js';
import parseJson from './parseJson.js';
export default (storageArea) => {
    const storage = createStorage(storageArea);
    return {
        ...storage,
        getItem(key, reviver) {
            return parseJson(storage.getItem(key), reviver);
        },
        setItem(key, value, replacer, space) {
            storage.setItem(key, JSON.stringify(value, replacer, space));
        },
    };
};
//# sourceMappingURL=createJsonStorage.js.map